import MAP_STYLES from './../config/map-styles'

class MapLocator {

  constructor () {
    this.map = null
    this.marker = []
    this.contentString = []
    this.$el = null
    this.$activeDetails = null
    this.activeShowroom = null
  }

  init ($el) {
    this.$el = $el
    this.bindEvents()
  }

  bindEvents () {
    $('.js-showroom-toggle').on('click', (e) => {
      this.onClick($(e.currentTarget).data('showroom-id'))
    })
  }

  onClick (id) {
    let $details = $(`[data-showroom-details-id=${id}]`)
    if (!$details.length) {
      return
    }
    if (this.$activeDetails) {
      this.$activeDetails.addClass('hidden')
    }
    $details.removeClass('hidden')
    this.$activeDetails = $details
    $('.js-showroom-toggle').removeClass('is-active')
    $('.map-locator__mobile-details').removeClass('is-active')
    $(`[data-showroom-id="${id}"]`).addClass('is-active')
    if (this.map) {
      let google = window.google
      let { lat, lng } = this.marker[id]
      this.map.panTo(new google.maps.LatLng(lat, lng))
    }
  }

  initMap () {
    let google = window.google
    this.map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: -38.0054794, lng: 145.2055317},
        zoom: 16,
        disableDefaultUI: true,
        styles: MAP_STYLES,
    });
    this.loadData(window._comfortel_showrooms)
  }

  loadData (locations = []) {
    let google = window.google
    this.marker = {};
    const image = {
        url: window._asset_url + '/images/common/map-pin.png',
        scaledSize: new google.maps.Size(116, 118),
    };
    let firstId = null
    locations.forEach((location) => {
      if (firstId === null) {
        firstId = location.id
      }
      let { lat, lng } = location.map_location
      let marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        icon: image,
        map: this.map,
      })
      this.marker[location.id] = {
        marker,
        lat,
        lng,
      };
    })
    if (firstId) {
      this.onClick(firstId)
    }
  }
}

const map = new MapLocator;
window._map_locator = map
export default map



// WEBPACK FOOTER //
// ./scripts/components/map-locator.js